<template>
  <div>
    <!-- IM通知弹窗 -->
    <el-dialog 
      title="IM 通知" 
      :visible.sync="dialogVisible" 
      width="60%" 
      :modal-append-to-body="true"
      append-to-body 
      close-on-click-modal 
      @opened="handleOpened"
      @closed="handleClosed">
      
      <!-- 通知发送区域 -->
      <div class="notify-send-section">
        <el-form :model="sendForm" :rules="sendRules" ref="sendForm" label-width="80px">
          <el-form-item label="Appid" prop="appid" required>
            <el-select 
              v-model="sendForm.appid" 
              filterable 
              :filter-method="dataFilter"
              clearable 
              placeholder="请选择渠道" 
              style="width: 100%"
              @visible-change="handleVisibleChange">
              <el-option 
                v-for="item in channelShowOptions" 
                :key="item.id" 
                :label="getChannelLabel(item)" 
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="uid" prop="uid" required>
            <el-input 
              v-model="sendForm.uid" 
              placeholder="多个用英文逗号隔开"
              clearable>
            </el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button 
              type="primary" 
              @click="sendNotification"
              :loading="sendLoading">
              确认通知
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <!-- 分隔线 -->
      <el-divider></el-divider>
      
      <!-- 通知记录区域 -->
      <div class="notify-records-section">
        <h4>推送记录</h4>
        
        <!-- 记录筛选 -->
        <div class="record-filters">
          <el-select 
            v-model="recordFilters.appid" 
            filterable 
            clearable 
            placeholder="选择渠道" 
            size="small"
            style="width: 200px; margin-right: 10px;"
            @change="loadRecords">
            <el-option 
              v-for="item in channelOptions" 
              :key="item.id" 
              :label="getChannelLabel(item)" 
              :value="item.id">
            </el-option>
          </el-select>
          
          <el-input 
            v-model="recordFilters.uid" 
            placeholder="输入UID" 
            size="small"
            style="width: 200px; margin-right: 10px;"
            @keyup.enter="loadRecords">
          </el-input>
          
          <el-select 
            v-model="recordFilters.status" 
            clearable 
            placeholder="选择状态" 
            size="small"
            style="width: 120px; margin-right: 10px;"
            @change="loadRecords">
            <el-option label="成功" :value="1"></el-option>
            <el-option label="失败" :value="0"></el-option>
          </el-select>
          
          <el-button type="primary" size="small" @click="loadRecords">搜索</el-button>
        </div>
        
        <!-- 记录表格 -->
        <el-table 
          :data="recordList" 
          v-loading="recordLoading"
          style="width: 100%; margin-top: 15px;">
          <el-table-column prop="id" label="#" width="60"></el-table-column>
          <el-table-column prop="createTime" label="通知时间" width="180"></el-table-column>
          <el-table-column prop="appid" label="Appid" width="200">
            <template slot-scope="scope">
              {{ getChannelLabelById(scope.row.appid) }}
            </template>
          </el-table-column>
          <el-table-column prop="uid" label="uid" min-width="150"></el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
                {{ scope.row.status === 1 ? '成功' : '失败' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
          style="margin-top: 15px; text-align: right;">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pushImMessage, getImPushRecords } from "@/api/apps/imPush";
import { appChannelList } from "@/api/member/index.js";
import Message from "@/components/Message";
import { debounce } from 'lodash';

export default {
  name: "ImNotifyDialog",
  
  data() {
    return {
      dialogVisible: false,
      
      // 发送表单
      sendForm: {
        appid: "",
        uid: ""
      },
      
      // 发送表单验证规则
      sendRules: {
        appid: [
          { required: true, message: "请选择渠道", trigger: "change" }
        ],
        uid: [
          { required: true, message: "请输入UID", trigger: "blur" }
        ]
      },
      
      // 发送加载状态
      sendLoading: false,
      
      // 渠道选项
      channelOptions: [], // 所有渠道数据
      channelShowOptions: [], // 展示的渠道数据
      
      // 记录筛选
      recordFilters: {
        appid: "",
        uid: "",
        status: ""
      },
      
      // 记录列表
      recordList: [],
      recordLoading: false,
      
      // 分页
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    };
  },
  
  methods: {
    /** 显示弹窗 */
    show() {
      this.dialogVisible = true;
    },
    
    /** 弹窗打开后 */
    handleOpened() {
      this.loadRecords();
    },
    
    /** 弹窗关闭后 */
    handleClosed() {
      this.resetForm();
    },
    
    /** 重置表单 */
    resetForm() {
      this.sendForm = {
        appid: "",
        uid: ""
      };
      this.recordFilters = {
        appid: "",
        uid: "",
        status: ""
      };
      this.pagination = {
        current: 1,
        size: 10,
        total: 0
      };
      this.recordList = [];
      this.$nextTick(() => {
        this.$refs.sendForm && this.$refs.sendForm.clearValidate();
      });
    },
    
    /** 发送通知 */
    sendNotification() {
      this.$refs.sendForm.validate(async (valid) => {
        if (!valid) return;
        
        this.sendLoading = true;
        try {
          await pushImMessage({
            appid: this.sendForm.appid,
            uid: this.sendForm.uid
          });
          Message.success("通知发送成功");
          // 发送成功后刷新记录列表
          this.loadRecords();
          // 通知父组件刷新
          this.$emit("reload");
        } catch (error) {
          console.error("发送通知失败", error);
          Message.error("发送通知失败");
        } finally {
          this.sendLoading = false;
        }
      });
    },
    
    /** 加载推送记录 */
    async loadRecords() {
      this.recordLoading = true;
      try {
        const params = {
          current: this.pagination.current,
          size: this.pagination.size,
          ...this.recordFilters
        };
        
        const { data } = await getImPushRecords(params);
        this.recordList = data.data.records || [];
        this.pagination.total = data.data.total || 0;
      } catch (error) {
        console.error("加载推送记录失败", error);
        Message.error("加载推送记录失败");
      } finally {
        this.recordLoading = false;
      }
    },
    
    /** 分页大小改变 */
    handleSizeChange(size) {
      this.pagination.size = size;
      this.pagination.current = 1;
      this.loadRecords();
    },
    
    /** 当前页改变 */
    handleCurrentChange(current) {
      this.pagination.current = current;
      this.loadRecords();
    },
    
    // 获取渠道列表
    async getChannelList() {
      try {
        const { data } = await appChannelList();
        if (data.code === 200) {
          this.channelOptions = data.data || [];
          // 初始只显示前50条数据
          this.channelShowOptions = this.channelOptions.slice(0, 50);
        }
      } catch (error) {
        console.error('获取渠道列表失败:', error);
      }
    },
    
    // 处理下拉框显示/隐藏
    handleVisibleChange(visible) {
      if (visible) {
        // 显示时重置为前50条数据减少dom渲染
        this.channelShowOptions = this.channelOptions.slice(0, 50);
      } else {
        this.channelShowOptions = [];
      }
    },
    
    // 过滤渠道数据
    dataFilter: debounce(function(val) {
      if (val) {
        // 在所有数据中搜索
        this.channelShowOptions = this.channelOptions.filter(item => 
          this.getChannelLabel(item).toLowerCase().indexOf(val.trim().toLowerCase()) !== -1
        );
      } else {
        // 无搜索词时显示前50条
        this.channelShowOptions = this.channelOptions.slice(0, 50);
      }
    }, 300),
    
    // 获取渠道显示文本
    getChannelLabel(item) {
      return `[${item.id}] ${item.name}`;
    },
    
    // 根据ID获取渠道显示文本
    getChannelLabelById(appid) {
      const channel = this.channelOptions.find(item => item.id === appid);
      return channel ? this.getChannelLabel(channel) : `(${appid})`;
    }
  },
  
  mounted() {
    this.getChannelList();
  }
};
</script>

<style lang="scss" scoped>
.notify-send-section {
  margin-bottom: 20px;
}

.notify-records-section {
  h4 {
    margin: 0 0 15px 0;
    color: #606266;
  }
}

.record-filters {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
</style>

